// removed by extract-text-webpack-plugin
module.exports = {"root":"index-root-26q8x"};


//////////////////
// WEBPACK FOOTER
// ./src/components/route/route-error/index.less
// module id = 752
// module chunks = 4